 <template>
  <div>

    <!-- SAMPLE SW -->
    <b-row>
      <b-col>
      <div class="row">
          <div class="samplesw">
            <b-button-group>
                <b-button id="samplesw1" :variant="btnvariant1" size="sm" type=button class="samplesw-cls" @click="swSample(0)">
                  <b-icon icon="tag"></b-icon> 0-9Number
                </b-button>
                <b-button id="samplesw2" :variant="btnvariant2" size="sm" type=button class="samplesw-cls" @click="swSample(1)">
                  <b-icon icon="camera-video-fill"></b-icon> Kit画像
                </b-button>
            </b-button-group>
          </div>
      </div>
      </b-col>
    </b-row>

  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'insamplesw',
  data () {
    return {
    }
  },
  computed: {
    ...mapState([ 'samplebtn', 'setModals' ]),
    btnvariant1 () {
      if (this.samplebtn === 'MNIST') {
        return 'primary'
      } else {
        return 'outline-primary'
      }
    },
    btnvariant2 () {
      if (this.samplebtn === 'KITDATA') {
        return 'primary'
      } else {
        return 'outline-primary'
      }
    }
  },
  methods: {
    swSample (swFlag) {
      // console.log('do swCamera')
      if (swFlag === 0) {
        this.$store.dispatch('sampleSw', 0)
      } else {
        this.$store.dispatch('sampleSw', 1)
      }
    }
  }
}
</script>

<style scoped>
.samplesw {
  padding: 0 0 0 15px;
  width: 200px;
  height: 40px;
}
.samplesw-cls {
  padding: 0;
  margin: 0;
  width: 100px;
  height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/InSampleSw.vue